import { useTranslation } from "react-i18next";

import { Box, Stack as MuiStack } from "@mui/material";

import { ChipStyled } from "./MobileTableRow.styled";

const Stack = ({ children }) => (
  <MuiStack direction="column" spacing="6px">
    {children}
  </MuiStack>
);

export const MobileTableRow = ({ ip, provider, status }) => {
  const { t } = useTranslation();

  return (
    <>
      <Stack>
        <Box>IP</Box>
        <Box>{ip}</Box>
      </Stack>
      <Stack>
        <Box>Provider</Box>
        <Box>{provider}</Box>
      </Stack>
      <Stack>
        <Box>Status</Box>
        <ChipStyled
          label={
            status
              ? t("webrtcCheck.possibleLeak")
              : t("webrtcCheck.notPossibleLeak")
          }
          color={status ? "error" : "primary"}
        />
      </Stack>
    </>
  );
};
